interface DateOfBirth {
  year: string;
  month: string;
  day: string;
}

const MONTH_NAMES: Record<string, number> = {
  january: 1, february: 2, march: 3, april: 4, may: 5, june: 6,
  july: 7, august: 8, september: 9, october: 10, november: 11, december: 12,
};

const parseMonth = (value: string): number => {
  const num = parseInt(value);
  if (!isNaN(num)) return num;
  return MONTH_NAMES[value.toLowerCase()] ?? NaN;
};

export const calculateAge = (dateOfBirth: DateOfBirth): number | null => {
  const year = parseInt(dateOfBirth.year);
  const month = parseMonth(dateOfBirth.month);
  const day = parseInt(dateOfBirth.day);

  if (isNaN(year)) {
    console.log('[calculateAge] year is NaN, returning null');
    return null;
  }

  const now = new Date();
  const todayMonth = now.getUTCMonth() + 1;
  const todayDay = now.getUTCDate();
  const todayYear = now.getUTCFullYear();

  let age = todayYear - year;

  const hadBirthday = !(!isNaN(month) && !isNaN(day)) || !(todayMonth < month || (todayMonth === month && todayDay < day));

  if (!isNaN(month) && !isNaN(day)) {
    if (todayMonth < month || (todayMonth === month && todayDay < day)) {
      age--;
    }
  }

  console.log('[calculateAge] today (UTC):', { todayYear, todayMonth, todayDay });
  console.log('[calculateAge] result:', { age, hadBirthday });

  return age;
};
